<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label class="text-info" v-if="label" :for="name">{{ label }}</label>
    <input type="email"
      @input="updateValue($event.target.value)"
      :value="value"
      :name="name"
      :required="required"
      :placeholder="placeholder"
      :disabled="disabled"
      class="form-control"
      autocomplete="on"
      >
    <span v-if="error"
          class="help-block"
          v-html="error"
          ></span>
  </div>
</template>

<script>
  export default{
    name: 'InputEmail',
    props: ['name', 'value', 'required', 'label', 'placeholder', 'error', 'disabled'],
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputEmail.vue?07114f7e